import { ADD_ITEM,TERM_SWITCH,PRIVACY_SWITCH,COOKIE_SWITCH } from "./actionTypes";

const initialState = {
  numOfItems: 0,
  privacyPolicy : 0,
  terms : 0,
  cookie: 0
};

export const toggleReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ITEM:
      return {
        ...state,
        numOfItems: state.numOfItems + 1,
      };

      case PRIVACY_SWITCH:
        return {
          ...state,
          privacyPolicy: state.privacyPolicy + 1,
      };

      case TERM_SWITCH:
        return {
          ...state,
          terms: state.terms + 1,
      };

      case COOKIE_SWITCH:
        return {
          ...state,
          cookie: state.cookie + 1,
      };

    default:
      return state;
  }
};